export default function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-function.js
// module id = 17
// module chunks = 0